import { Container, Text } from '@chakra-ui/react'

import Head from 'next/head'
import { MainLayout } from '@/layouts'
import { PostStaticProps } from '@/pages/posts/[slug]'
import { PostView } from '@/components'
import getPostTitle from '@/helpers/getPostTitle'
import getPostUrl from '@/helpers/getPostUrl'

const Post = ({ post }: PostStaticProps) => {
  if (!post) return <Text>Cannot retrieve post data</Text>

  const postTitle = getPostTitle(post.postTitle?.document)
  return (
    <MainLayout>
      <Head>
        <title>{postTitle}</title>
        <meta property="og:url" content={getPostUrl(post.slug)} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={postTitle} />
        <meta property="og:description" content={postTitle} />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/hfq3eckim/image/upload/v1644397231/cms-demo/Projects%20Thumbnails/post-default_pmwqzi.png"
        />
      </Head>
      <Container maxW="container.xl" minH="calc(100vh - 100px)">
        {post && <PostView post={post} />}
      </Container>
    </MainLayout>
  )
}

export default Post
